import { lazy } from "react";

/* ================= Auth Screens ===============*/
export const SignIn = lazy(() => import("../pages/Auth/SignIn"));
export const Register = lazy(() => import("../pages/Auth/Register"));
export const ForgetPassword = lazy(() => import("../pages/Auth/ForgetPassword"));
export const ResetPassword = lazy(() => import("../pages/Auth/ResetPassword"));

/* ================= Reporting ================= */
export const SaleReporting = lazy(() => import("../pages/reporting/SaleReporting"));
export const SaleSummary = lazy(() => import("../pages/reporting/SaleSummary"));

/* ================= Dashboard ================= */
export const Dashbaord = lazy(() => import("../pages/dashboard/Dashboard"));
export const AfterSalesDashboard = lazy(() => import("../pages/dashboard/AfterSalesDashboard"));
export const WorkBayDashboard = lazy(() => import("../pages/dashboard/WorkBayDashboard"));
export const TechnicianDashboard = lazy(() => import("../pages/dashboard/TechnicianDashboard"));

/* ================= Setup Screens ================= */
export const Technician = lazy(() => import("../pages/setup/Technician"));
export const Bank = lazy(() => import("../pages/setup/Bank"));
export const City = lazy(() => import("../pages/setup/City"));
export const Color = lazy(() => import("../pages/setup/Color"));
export const Company = lazy(() => import("../pages/setup/Company"));
export const Customer = lazy(() => import("../pages/setup/CustomerProfile"));
export const Dealer = lazy(() => import("../pages/setup/Dealer"));
export const User = lazy(() => import("../pages/setup/User"));
export const UserRoles = lazy(() => import("../pages/setup/UserRoles"));
export const Stock = lazy(() => import("../pages/setup/Stock"));
export const Quota = lazy(() => import("../pages/setup/Quota"));
export const CorporateClient = lazy(() => import("../pages/setup/CorporateClients"));
export const WorkerShifts = lazy(() => import("../pages/setup/WorkerShifts"));
export const WorkerTypes = lazy(() => import("../pages/setup/WorkerTypes"));
export const WorkerTeams = lazy(() => import("../pages/setup/WorkerTeams"));
export const Skills = lazy(() => import("../pages/setup/Skills"));
export const Customers = lazy(() => import("../pages/setup/Customers"));
export const JobCategories = lazy(() => import("../pages/setup/JobCategories"));
export const Vendor = lazy(() => import("../pages/setup/Vendor"));
export const Tax = lazy(() => import("../pages/setup/Tax"));
export const Source = lazy(() => import("../pages/setup/Source"));
export const Item = lazy(() => import("../pages/setup/Item"));
export const CustomerProfile = lazy(() => import("../pages/setup/CustomerProfile"));

/* ================= Parts Setup ================= */
export const Category = lazy(() => import("../pages/setup/parts/Category"));
export const Parts = lazy(() => import("../pages/setup/parts/Parts"));
export const Make = lazy(() => import("../pages/setup/parts/Make"));
export const Model = lazy(() => import("../pages/setup/parts/Model"));
export const Variant = lazy(() => import("../pages/setup/parts/Variant"));
export const ColorsParts = lazy(() => import("../pages/setup/parts/ColorsParts"));

/* ================= Auth Setup ================= */
export const Privileges = lazy(() => import("../pages/setup/Auth/Privileges"));
export const RolesSetup = lazy(() => import("../pages/setup/Auth/RolesSetup"));
export const UsersSetup = lazy(() => import("../pages/setup/Auth/UsersSetup"));
export const Module = lazy(() => import("../pages/setup/Auth/Module"));
export const Screen = lazy(() => import("../pages/setup/Auth/Screen"));
export const SubScreens = lazy(() => import("../pages/setup/Auth/SubScreens"));
export const RolesPrivileges = lazy(() => import("../pages/setup/Auth/RolesPrivileges"));
export const MasterSetupScreen = lazy(() => import("../pages/setup/Auth/MasterSetupScreen"));

/* ================= Pre Sales ================= */
export const Lead = lazy(() => import("../pages/preSales/Lead"));
export const Opportunity = lazy(() => import("../pages/preSales/Opportunity"));
export const Quotation = lazy(() => import("../pages/preSales/Quotation"));
export const TestDrive = lazy(() => import("../pages/preSales/TestDrive"));
export const Visiting = lazy(() => import("../pages/preSales/Visiting"));
export const QuotationDetails = lazy(() => import("../pages/preSales/QuotationDetails"));
export const LeadDetails = lazy(() => import("../pages/preSales/LeadDetails"));

/* ================= PBO ================= */
export const PBOadd = lazy(() => import("./../pages/pbo/PBOadd"));
export const PBOdetails = lazy(() => import("../pages/pbo/PBOdetails"));
export const PBOinquiries = lazy(() => import("../pages/pbo/PBOinquiries"));
export const CustomerTransactions = lazy(() => import("../pages/pbo/CustomerTransactions"));
export const SalesFilesUpload = lazy(() => import("../pages/pbo/SalesFilesUpload"));
export const SalesInquiries = lazy(() => import("../pages/pbo/SalesInquiries"));
export const Payments = lazy(() => import("../pages/pbo/Payments"));
export const CancelandChangeSaleRequest = lazy(() => import("../pages/pbo/CancelandChangeSaleRequest"));
export const CancelledSales = lazy(() => import("../pages/pbo/CancelledSales"));
export const InvoiceRequest = lazy(() => import("../pages/pbo/InvoiceRequest"));
export const Test = lazy(() => import("../pages/pbo/test"));
export const InvoiceOrder = lazy(() => import("../pages/pbo/InvoiceOrder"));

/* ================= Quota Request ================= */
export const QuotaRequest = lazy(() => import("../pages/setup/QuotaRequest"));

/* ================= After Sales ================= */
export const AddCrmAppointment = lazy(() => import("../pages/afterSales/AddCrmAppointment"));
export const AddVehicle = lazy(() => import("../pages/afterSales/AddVehicle"));
export const CrmAppointments = lazy(() => import("../pages/afterSales/CrmAppointments"));
export const DqirInquiries = lazy(() => import("../pages/afterSales/DqirInquiries"));
export const EstimatesInquiries = lazy(() => import("../pages/afterSales/EstimatesInquiries"));
export const InvoiceInquirires = lazy(() => import("../pages/afterSales/InvoiceInquirires"));
export const PartsRequisitionInquiries = lazy(() => import("../pages/afterSales/PartsRequisitionInquiries"));
export const PurchaseOrderInquiries = lazy(() => import("../pages/afterSales/PurchaseOrderInquiries"));
export const WarrantyInquiries = lazy(() => import("../pages/afterSales/WarrantyInquiries"));
export const VehicleServiceHistory = lazy(() => import("../pages/afterSales/VehicleServiceHistory"));
export const JobCard = lazy(() => import("../pages/afterSales/JobCard"));
export const JobCardInquiries = lazy(() => import("../pages/afterSales/JobCardInquiries"));
export const JobCardDetail = lazy(() => import("../pages/afterSales/JobCardDetail"));
export const JobCardInspectionDetail = lazy(() => import("../pages/afterSales/JobCardInspectionsDetails"));
export const JobCardEstimation = lazy(() => import("../pages/afterSales/JobCardEstimation"));
export const JobCardInspections = lazy(() => import("../pages/afterSales/JobCardInspection"));
export const AddPurchaseOrder = lazy(() => import("../pages/afterSales/AddPurchaseOrder"));
export const AddPartsCounterSale = lazy(() => import("../pages/afterSales/AddPartsCounterSale"));
export const CustomersList = lazy(() => import("../pages/afterSales/CustomersList"));
export const PostServiceFollowUp = lazy(() => import("../pages/afterSales/PostServiceFollowUp"));
export const AppointmentReconfirmation = lazy(() => import("../pages/afterSales/AppointmentReconfirmation"));
export const StockMovement = lazy(() => import("../pages/afterSales/StockMovement"));
export const VehicleMasterList = lazy(() => import("../pages/afterSales/VehicleMasterList"));
export const Workshop = lazy(() => import("../pages/afterSales/WorkshopLoading"));
export const WorkshopView = lazy(() => import("../pages/afterSales/WorkshopView"));
export const YearCalender = lazy(() => import("../pages/afterSales/YearCalender"));
export const WorkshopHoliday = lazy(() =>import("../pages/setup/WorkshopHoliday"));

/* ================= Inventory ================= */
export const PurchaseItem = lazy(() => import("../pages/inventory/PurchaseItem"));
export const PurchaseReturnList = lazy(() => import("../pages/inventory/PurchaseReturnList"));
export const PurchaseOrderList = lazy(() => import("../pages/inventory/PurchaseOrderList"));
export const PurchaseDeliveryNote = lazy(() => import("../pages/inventory/PurchaseDeliveryNote"));
export const PurchaseDeliveryNoteList = lazy(() => import("../pages/inventory/PurchaseDeliveryNoteList"));
export const SaleDeliveryNote = lazy(() => import("../pages/inventory/SaleDeliveryNote"));
export const PurchaseOrderDetail = lazy(() => import("../pages/inventory/PurchaseOrderDetail"));
export const PurchaseReturnExchange = lazy(() => import("../pages/inventory/PurchaseReturnExchange"));
export const PartsIssue = lazy(() => import("../pages/inventory/PartsIssue"));
export const SaleItem = lazy(() => import("../pages/inventory/SaleItem"));
export const SaleDeliveryNoteList = lazy(() => import("../pages/inventory/SaleDeliveryNoteList"));
export const SaleOrderList = lazy(() => import("../pages/inventory/SaleOrderList"));
export const SaleOrderDetail = lazy(() => import("../pages/inventory/SaleOrderDetail"));
export const PartsStock = lazy(() => import("../pages/inventory/PartsStock"));
export const SaleReturnExchange = lazy(() => import("../pages/inventory/SaleReturnExchange"));
export const SaleReturnList = lazy(() => import("../pages/inventory/SaleReturnList"));

/* ================== CRM =================== */
export const CrmInquiry = lazy(() => import("../pages/crm/CrmInquiry"));
export const CrmInquiryDetails = lazy(() => import("../pages/crm/CrmInquiryDetails"));
export const CrmComplaint = lazy(() => import("../pages/crm/CrmComplaint"));
export const CrmComplaintDetails = lazy(() => import("../pages/crm/CrmComplaintDetails"));

/* ================= Errors ================= */
export const Error404 = lazy(() => import("../pages/extra/error404"));
export const Error500 = lazy(() => import("../pages/extra/error500"));


